import { render } from "./Mongolia.vue?vue&type=template&id=75978ee9"
import script from "./Mongolia.vue?vue&type=script&lang=js"
export * from "./Mongolia.vue?vue&type=script&lang=js"

import "./Mongolia.vue?vue&type=style&index=0&id=75978ee9&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__